<template>
  <v-app>
    <v-main class="pt-0">
      <router-view />
      <div>
        <v-overlay :value="isLoadingOverlay">
          <v-progress-circular
            indeterminate
            size="64"
          ></v-progress-circular>
        </v-overlay>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapState("utils", ["isLoadingOverlay"]),
  },
  methods: {
    ...mapActions("auth", ["getUser"]),
  },
  async mounted() {
    console.log('app mounted')
    await this.getUser()
  }
};
</script>

<style>
/* .v-application {
  background-color: #00a86b;
} */
.theme--dark.v-application {
  background-color: var(--v-background-base, #1a1b23) !important;
}
.mybackground {
  /* background-size: 100%; */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* filter: blur(1px);
  -webkit-filter: blur(1px) */
}
</style>
